export default __webpack_public_path__ + "static/media/Manrope-ExtraBold.1d1caae3.ttf";